import type { ReactNode } from 'react';
import Script from 'next/script';
import { useEsusu } from '../contexts/EsusuContext';

interface LayoutProps {
  children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { setIsEsusuScriptLoaded } = useEsusu();

  const handleEsusuLoad = () => {
    setIsEsusuScriptLoaded(true);
  };

  return (
    <>
      <Script src="https://sdk.esusu.io/latest/sdk.min.js" onLoad={handleEsusuLoad} />
      {children}
    </>
  );
}
